<template>
  <div id="app">
    <div id="nav">
      <header-menu v-if="$route.name != 'Login'"></header-menu>
      <main-menu v-if="$route.name != 'Login'"></main-menu>
    </div>
    <router-view />
  </div>
</template>
<script>
import HeaderMenu from "./components/HeaderMenu";
import MainMenu from "./components/MainMenu";
export default {
  data() {
    return {};
  },
  components: {
    "main-menu": MainMenu,
    "header-menu": HeaderMenu,
  },
};
</script>
<style>
.blink {
  animation: blinker 2s linear infinite;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* ========================================= */
/* ULEPSZONE STYLOWANIE v-select (UX/UI) */
/* ========================================= */
.v-select {
  background-color: #ffffff;
  border-radius: 8px;
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  transition: all 0.2s ease;
  margin: 0 auto;
}

/* Główny kontener */
.v-select .vs__dropdown-toggle {
  padding: 10px 14px;
  border: 2px solid #e0e4e8;
  border-radius: 8px;
  background-color: #ffffff;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.25s ease;
}

.v-select .vs__dropdown-toggle:hover {
  border-color: #b0bac9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Selected item(s) */
.v-select .vs__selected {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 6px 12px;
  color: white;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.v-select .vs__selected:hover {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  transform: translateY(-1px);
}

/* Kontener na selected items - zajmie miejsce po lewej */
.v-select .vs__selected-options {
  display: flex;
  align-items: center;
  flex-grow: 1;
  flex-wrap: nowrap;
}

/* Search input */
.v-select .vs__search {
  padding: 8px 6px;
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #1a2332;
  font-weight: 400;
  border: none;
}

.v-select .vs__search::placeholder {
  color: #8b95a5;
  font-weight: 400;
}

.v-select .vs__search:focus {
  outline: none;
}

/* Ukryj input gdy searchable=false */
.v-select.vs--unsearchable .vs__search {
  display: none;
  width: 0;
  padding: 0;
  margin: 0;
}

.v-select.vs--unsearchable .vs__selected {
  width: 100%;
  margin: 0;
}

/* Actions (clear & dropdown arrow) - po prawej stronie */
.v-select .vs__actions {
  padding: 6px 10px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
}

.v-select .vs__clear,
.v-select .vs__open-indicator {
  fill: #6b7785;
  transition: all 0.2s ease;
}

.v-select .vs__clear:hover {
  fill: #dc3545;
}

.v-select .vs__open-indicator {
  transition: transform 0.25s ease;
}

/* Dropdown menu */
.v-select .vs__dropdown-menu {
  border: 2px solid #e0e4e8;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
  max-height: 320px;
  overflow-y: auto;
  margin-top: 6px;
  background-color: #ffffff;
  z-index: 9999;
  padding: 6px 0;
}

/* Smooth scrollbar */
.v-select .vs__dropdown-menu::-webkit-scrollbar {
  width: 8px;
}

.v-select .vs__dropdown-menu::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 4px;
}

.v-select .vs__dropdown-menu::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

.v-select .vs__dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

/* Dropdown options */
.v-select .vs__dropdown-option {
  padding: 12px 18px;
  color: #2d3748;
  font-size: 15px;
  line-height: 1.5;
  white-space: normal;
  word-wrap: break-word;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  margin: 2px 6px;
  border-radius: 6px;
}

.v-select .vs__dropdown-option:hover {
  background-color: #f7fafc;
}

.v-select .vs__dropdown-option--highlight {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 500;
  transform: translateX(2px);
}

.v-select .vs__dropdown-option--selected {
  background-color: #e6f2ff;
  color: #0055cc;
  font-weight: 600;
  position: relative;
}

.v-select .vs__dropdown-option--selected::before {
  content: '✓';
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  font-weight: bold;
  color: #0055cc;
}

.v-select .vs__dropdown-option--selected {
  padding-left: 32px;
}

.v-select .vs__dropdown-option--selected.vs__dropdown-option--highlight {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.v-select .vs__dropdown-option--selected.vs__dropdown-option--highlight::before {
  color: white;
}

/* No options */
.v-select .vs__no-options {
  padding: 20px 18px;
  color: #8b95a5;
  font-style: italic;
  text-align: center;
  font-size: 14px;
}

/* Open state - lepsze visual feedback */
.v-select.vs--open .vs__dropdown-toggle {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.v-select.vs--open .vs__open-indicator {
  transform: rotate(180deg);
  fill: #667eea;
}

/* Focus state */
.v-select.vs--searchable .vs__dropdown-toggle:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* Disabled state */
.v-select.vs--disabled .vs__dropdown-toggle,
.v-select.vs--disabled .vs__clear,
.v-select.vs--disabled .vs__search,
.v-select.vs--disabled .vs__selected,
.v-select.vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #f7fafc;
  opacity: 0.5;
  pointer-events: none;
}

/* Loading state */
.v-select .vs__spinner {
  border: 3px solid rgba(102, 126, 234, 0.2);
  border-top-color: #667eea;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: vs-spinner 0.8s linear infinite;
}

@keyframes vs-spinner {
  to { transform: rotate(360deg); }
}

/* Deselect button (X) styling - mniejszy */
.v-select .vs__deselect {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  padding: 0;
  width: 14px;
  height: 14px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transition: all 0.2s ease;
}

.v-select .vs__deselect:hover {
  background-color: rgba(255, 255, 255, 0.5);
  transform: scale(1.15);
}

.v-select .vs__deselect svg {
  width: 10px;
  height: 10px;
  fill: white;
}

/* Responsywność */
@media (max-width: 768px) {
  .v-select .vs__dropdown-toggle {
    min-height: 44px;
    padding: 8px 12px;
  }
  
  .v-select .vs__dropdown-option {
    padding: 10px 16px;
    font-size: 14px;
  }
  
  .v-select .vs__dropdown-menu {
    max-height: 240px;
  }
}
</style>
